import React from 'react';
import styles from './MaintenanceAlert.module.css';
import * as PropTypes from 'prop-types';

const propTypes = {
  message: PropTypes.string.isRequired,
};
function MaintenanceAlert({ message }) {
  return <div className={styles['alert-container']}>{message}</div>;
}

MaintenanceAlert.propTypes = propTypes;

export default MaintenanceAlert;
